import {validateTokenAndGetUserInfo} from '@/api/api';
import {TokenInfo} from '@/pages/NewUserOnboarding/types';
import {useQuery} from '@tanstack/react-query';

export const useValidateTokenAndGetUserInfo = ({token}: {token: string}) => {
  return useQuery<TokenInfo>({
    queryKey: ['validate-token', token],
    queryFn: () => validateTokenAndGetUserInfo(token),
    enabled: !!token,
  });
};
